<div class="screener-container">
  <div class="form-section">
    <div class="row">
      <div class="col-md-6 mb-4">
        <p class="text-steps">STEP 1</p>
        <div class="d-flex justify-content-between flex-sm-row flex-column">
          <p class="step-title">Enter Job Description </p>

        </div>
        <textarea data-testid="auto-app-ai-resume-form-textarea-1" name="jobDescription" id="jobDescription" autofocus placeholder="Enter or paste Job Description "
          (click)="JdClick()" [formControl]="jobDescription" class="ai-screen-form-input"></textarea>
          <p class="text-danger f-12 pt-1 mb-0" *ngIf="jobDescription.hasError('Invalid') &&
            (jobDescription.dirty || jobDescription.touched)">
                    Invalid Job Description </p>
      </div>
      
      <div class="col-md-6 mb-4">
        <p class="text-steps">STEP 2</p>
        <p class="step-title">Upload Resumes</p>

        <div class="ats-upload-btn d-flex justify-content-center align-items-center" *ngIf="resumeStatus=='upload'">
          <div class="col text-center p-5 ng-star-inserted">
            <div class="col px-0">
              <p class="font-weight-500 f-14 text-bluex mb-1"> Drag and drop or click here to select multiple files</p>
              <p class="f-12 font-weight-normal text-center text-9696 line-height-1 mb-1">Accepted file type: PDF<br>
                Max files: 10 | File Size: 5MB </p>
            <p class="f-10 font-weight-normal text-center text-9696 line-height-1 mb-0">Disclaimer:
 For your privacy and data security, all uploaded resumes are stored securely and automatically deleted within 24 hours. Webbtree does not retain or use these files beyond the screening process.</p>
            </div>
          </div>
          <input data-testid="auto-app-ai-resume-form-input-1" accept=".pdf" type="file" class="ng-star-inserted" multiple="true" (change)="uploadResume($event);"
            >
        </div>
        <div class="bulkparse-upload text-center mb-2" *ngIf="resumeStatus=='ongoing'">
          <p class="mb-1 text-center"><strong>{{totalFilesUploaded}} out of {{fileList.length}}</strong> uploaded</p>
          <ngb-progressbar type="success" class="mb-1" [value]="totalFilesUploaded"
            [max]="fileList.length"></ngb-progressbar>
          <p class="text-center" style="margin-top: 13px;" *ngIf="idx<fileList.length || totalFilesUploaded < 10">Uploading in process</p>
          <div class="" *ngIf="idx>=fileList.length">

            <p class="mt-2 f-12"> <i class="fas fa-exclamation-circle" style="color: #f3c04c;"
                *ngIf="totalFilesSucessfullyUploaded<fileList.length"></i>
              <i class="fas fa-check-circle" *ngIf="totalFilesSucessfullyUploaded>=fileList.length"
                style="color: #229300;"></i>
              {{totalFilesSucessfullyUploaded}} out of {{fileList.length}} were successfully uploaded
            </p>
          </div>
        </div>
        <p class="text-danger f-14 mt-2" *ngIf="showMaxFileError">
          {{ maxFileErrorMessage }}
        </p>
        <p class="f-14 font-weight-600" *ngIf="fileInfoList?.length > 0">
          {{totalFilesSucessfullyUploaded}} Uploaded Successfully, {{totalFilesUploadedFailed}} Failed</p>
        <div *ngFor="let file of fileInfoList">
          <div class="d-flex justify-content-between">
            <div class="d-flex" style="word-break:break-word">
              <div>
                <span *ngIf="file?.status=='complete'"><i class="fas fa-check-circle"
                    style="color: #229300;"></i></span>
                <span *ngIf="file?.status=='fail'"><i class="fas fa-exclamation-circle"
                    style="color: #af2c2c;"></i></span>
                <span *ngIf="file?.status=='load'">
                  <div class="spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </span>
              </div>
              <div class="ml-1">
                <p class="mb-0" *ngIf="file.filename.length>0 && file.candidatename.length==0">{{file.filename}}</p>
              </div>
            </div>
            <div style="text-align: right;" *ngIf="showEvaluation">
              <p class="text-danger mb-0" *ngIf="file?.message?.length>0">{{file.message}}</p>
              <span (click)="deleteResume(file)" class="pointer">
                <i class="fa-solid fa-trash"></i>
              </span>
            </div>
          </div>
          <hr class="my-3">
        </div>
      </div>
    </div>
    <div class="row flex-sm-row flex-column">
      <div class="col-md-6">
        <p class="text-steps">STEP 3</p>
        <p class="step-title">Enter Criteria (Add at least 1, up to 5)</p>
      </div>
      <div class="col-md-6">
        <div class="learnmorebox">
          <p class="mb-0"><i class="fa-regular fa-lightbulb-on mr-2"></i> How to write prefect criteria <a data-testid="auto-app-ai-resume-form-a-1"
              class="font-weight-600 f-14 text-bluex pointer"  href="https://fire-crib-a04.notion.site/How-to-Create-Smart-AI-Screening-Criteria-268d71872fa5805abf9bc8914371f5d6" target="_blank"> Learn More</a></p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div [formGroup]="aiScreeningCriteriaForm">
          <div cdkDropList (cdkDropListDropped)="onDrop($event)" class="example-list">
            <div *ngFor="let key of formLength(); let id = index" [formGroupName]="key" class="example-box" cdkDrag>
              <div class="mb-2">
                Criteria {{ id + 1 }}
              </div>
              <div class="d-flex w-100 align-items-center">
                <div>
                  <span>
                    <i class="fa-solid fa-caret-up"></i>
                  </span>
                  <span>
                    <i class="fa-solid fa-caret-down"></i>
                  </span>
                </div>

                <div class="w-100">
                  <input data-testid="auto-app-ai-resume-form-input-2" type="text" formControlName="question"
                    placeholder="Solid understanding of user-centered design principles and best practices."
                    class="wc-form-control">
                  <p class="text-danger f-12 pt-1 mb-0" *ngIf="aiScreeningCriteriaForm.get(key)?.get('question')?.hasError('incorrect') &&
            (aiScreeningCriteriaForm.get(key)?.get('question')?.dirty ||
             aiScreeningCriteriaForm.get(key)?.get('question')?.touched)">
                    Invalid Evaluation Criteria </p>



                </div>
                <div class="text-right pointer ml-1" *ngIf="formLength().length > 1 && showEvaluation">
                  <span (click)="deleteCriteria(key)">
                    <i class="far fa-trash f-14" style="color: #EC221F;"></i>
                  </span>
                </div>
              </div>

            </div>

          </div>
        </div>
        <div class="ai-suggestion-box mb-5 w-100" *ngIf="formLength().length < 5">

          <p class="f-14 font-weight-400 mb-2" *ngIf="SUGGESTED_CRITERIA.length > 0"><i class="fa-solid fa-stars"
              style="color: #E24E7F;"></i> AI Suggestions</p>
          <div class="ai-suggestion pointer" *ngFor="let c of SUGGESTED_CRITERIA | slice:0:5">
            <ng-container *ngIf="!c.selected">
              <p class="ai-screening-chips mb-0" (click)="useGivenCriteria(c)">
                <i class="fa-solid fa-plus mr-2 mt-1"></i>
                <span>{{c.suggestion_content}}</span>
              </p>
            </ng-container>
          </div>

        </div>
        <div class="click-to-more-criteria-btn mb-5" *ngIf="formLength().length < 5"
          (click)="formLength().length < 5 && showEvaluation && addNewCriteria()"
          [ngClass]="{'disable-btn': !showEvaluation}">
          + Click to Add more criteria
        </div>
        <button data-testid="auto-app-ai-resume-form-button-1" class="btn-trms-medium mx-auto d-flex px-8 align-items-center" *ngIf="showEvaluation"
          [disabled]="evaluationButtonDisabled" [ngClass]="{'disable-btn': evaluationButtonDisabled}"
          (click)="getCandidates()">Evaluate
          Resumes</button>
      </div>
    </div>
  </div>
</div>
